import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { GraphPie } from 'features/CallAnalytics/GraphPie'
import { flow, groupBy, map } from 'lodash/fp'

const mapWithKey = (map as any).convert({ cap: false })

const formatData = flow(
  groupBy('incomingCallType'),
  mapWithKey((items, key) => ({
    value: items.length,
    label: key,
  }))
)

export const CallsByOriginPie = ({ calls, loading }) => {
  const data = formatData(calls)
  return (
    <InfoCard
      style={{ height: '100%' }}
      title="Calls by origin type"
      loading={loading}
      allowOverflow
    >
      <ParentSize>{({ width }) => <GraphPie width={width} height={400} data={data} />}</ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsByOriginPie/CallsByOriginPie.tsx